import { styled } from "@mui/material/styles";

import { IMAGES } from "@/assets/images";

const DashboardStyled = styled("div")(({ theme }) => ({
  "& .document": {
    background: "#EAF6FF",
    height: "132px",
    width: "290px",
    borderRadius: "10px",
    alignItems: "flex-start",
    textAlign: "center",
    margin: "10px",
  },
  // "& .dailyNotes": {
  //   marginTop: "12%",
  // },
  "&.MuiBox-root ": {
    marginTop: "0!important",
  },

  "& .JobCard": {
    width: "100% !important",
    margin: "auto",
    marginTop: "0 !important",
    paddingBottom: "2px !important",
    paddingTop: "0",
  },
  "& .JobCardLayout": {
    width: "100% !important",
    margin: "auto",
    marginTop: "0 !important",
    paddingBottom: "2px !important",
    paddingTop: "0",
  },
  "& .jobRole": {
    paddingTop: "6px",
    paddingBottom: "7px",
  },
  "& .dailyNotes": {
    marginTop: "0",
  },
  "& .dashboard-content": {
    paddingTop: "0",
    minWidth: 0,
    overflowX: "clip",
  },
  "& .medicationList": {
    color: "#1F4970",
    flex: "0 0 auto",
    fontSize: "14px",
    fontWeight: "500",
    padding: "0 12px 0 4px",
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
  },
  "& .medicationList svg": {
    flex: "0 0 auto",
    margin: "0 6px 0 0",
  },
  "& .LIST": {
    fontSize: "14px",
    fontWeight: "500",
    fontFamily: "Poppins",
    color: "rgb(42, 53, 71)",
    textOverflow: " ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "230px",
  },
  "& .list": {
    fontSize: "14px",
    fontWeight: "500",
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "center",
    maxWidth: "150px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "& .List": {
    fontSize: "14px",
    fontWeight: "500",
    padding: "0px 12px 0px",
    fontFamily: "Poppins",
  },
  // "& .weekList": {
  //   padding: "6px 12px 0px",
  // },
  "& .series-list": {
    fontFamily: "Poppins",
    color: "#1f4970",
    padding: "5px 9px !important",
    width: "100% !important",
    minWidth: 0,
  },
  "& .topBannerSection .monitoring": {
    minHeight: "78px!important",
    transition: "all 0.3s",
    "&:hover": {
      boxShadow: "0px 0px 10px 0px #0000001a",
    },
  },
  "& .monitoring": {
    margin: "0px 7px !important",
    // minHeight: "78px!important",
    background: "#EAF6FF",
    borderRadius: "10px",
    padding: "0px !important",
    transition: "all 0.3s",
    "&:hover": {
      boxShadow: "0px 0px 10px 0px #0000001a",
    },
  },
  "& .upgradeMonitoring img": {
    transition: "all 0.3s",
  },
  "& .upgradeMonitoring img:hover": {
    boxShadow: "0px 0px 10px 0px #0000001a",
  },

  "& p.content": {
    margin: " 0",
    width: "100%",
    maxWidth: "263px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    color: "#000",
    textTransform: "capitalize",
  },
  "& .view": {
    display: "flex",
    alignItems: "center",
    margin: "0px 10px",
    color: "#3E73A4",
    cursor: "pointer",
  },
  "& .weekly": {
    height: "166px",
    textAlign: "center",
  },
  // "& .addMember": {
  //   padding: "0 0px 0 8px !important",
  //   textAlign: "center",
  //   display: "flex",
  //   justifyContent: "center",
  //   // position: "absolute !important",
  //   // top: "288px",
  //   width: "282px !important",
  // },
  "& .added": {
    color: "#00261C",
    fontSize: "16px",
    fontWeight: "500",
    paddingTop: "18px",
    paddingBottom: "18px",
  },
  " .state": {
    color: "#3E73A4",
    fontSize: "16px",
    fontWeight: "500",
    paddingTop: "18px",
    paddingBottom: "18px",
  },

  "& .memberAdd": {
    float: "right",
  },

  "& .care": {
    display: "flex",
    justifyContent: "space-between",
    textTransform: "capitalize",
    padding: "10px",
  },

  "& .myCare": {
    display: "flex",
    justifyContent: "space-between",
    textTransform: "capitalize",
    padding: "10px",
  },

  "& .title": {
    fontSize: "40px",
    fontWeight: "500",
    color: "#00261C",
    alignSelf: "center",
  },

  "& .option": {
    color: "#00261C",
    fontSize: "16px",
    fontWeight: "600",
  },
  "& .jobRoleTask": {
    position: "relative",
  },
  "& .jobRoleMedication": {
    boxSizing: "border-box",
    paddingBottom: "24px",
  },
  "& .team": {
    position: "relative",
  },
  "& .dashboard-panel-action": {
    display: "flex",
    width: "100%",
    minWidth: 0,
    marginTop: "auto",
    padding: "16px 6px 10px",
    boxSizing: "border-box",
    flex: "0 0 auto",
    "& > a": {
      display: "block",
      width: "100%",
    },
    "& .addMember": {
      margin: 0,
      width: "100%",
    },
  },
  "& .dashboardchart": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "240px",
    height: "240px",
    minWidth: 0,
    overflow: "hidden",
    boxSizing: "border-box",
    "& .apexcharts-canvas, & .apexcharts-svg": {
      maxWidth: "100% !important",
      width: "100% !important",
    },
  },
  "& .dashboard-main-panels > .MuiGrid-root": {
    display: "flex",
    maxWidth: "100%",
    minWidth: 0,
    height: "440px",
  },
  "& .dashboard-main-panels > .dashboard-visits-panel": {
    height: "auto",
    minHeight: "440px",
  },
  "& .dashboard-main-panels > .MuiGrid-root > *": {
    display: "flex",
    flex: 1,
    minWidth: 0,
    minHeight: 0,
  },
  "& .dashboard-main-panels > .MuiGrid-root > * > *": {
    display: "flex",
    flex: 1,
    width: "100%",
    minWidth: 0,
    minHeight: 0,
  },
  "& .dashboard-main-panels .JobCard, & .dashboard-main-panels .CardData, & .dashboard-main-panels .CardData > div":
    {
      display: "flex",
      flex: 1,
      minWidth: 0,
      minHeight: 0,
    },
  "& .dashboard-main-panels .JobCard": {
    height: "100%",
    marginBottom: 0,
  },
  "& .dashboard-main-panels .CardData": {
    height: "100%",
    maxWidth: "100%",
    overflow: "hidden",
  },
  "& .dashboard-main-panels .LastWeekData": {
    width: "100% !important",
    boxSizing: "border-box",
  },
  "& .dashboard-main-panels .CardData > div, & .dashboard-main-panels .jobRole, & .dashboard-main-panels .jobRoleTask, & .dashboard-main-panels .jobRoleMedication, & .dashboard-main-panels .team, & .dashboard-main-panels .dashboard-panel-content":
    {
      display: "flex",
      flexDirection: "column",
    },
  "& .dashboard-main-panels .jobRole, & .dashboard-main-panels .jobRoleTask, & .dashboard-main-panels .jobRoleMedication, & .dashboard-main-panels .team, & .dashboard-main-panels .dashboard-panel-content":
    {
      flex: 1,
      minHeight: 0,
    },
  "& .dashboard-main-panels .dashboard-scroll-region-shell, & .dashboard-main-panels .dashboard-chart-content":
    {
      flex: 1,
      minWidth: 0,
      minHeight: 0,
      boxSizing: "border-box",
    },
  "& .dashboard-main-panels .dashboard-scroll-region > .MuiGrid-container": {
    alignContent: "flex-start",
    boxSizing: "border-box",
    minWidth: 0,
    paddingBottom: "16px",
    width: "100%",
  },
  "& .dashboard-panel-loader": {
    display: "grid",
    flex: "1 0 100%",
    gridColumn: "1 / -1",
    placeItems: "center",
    width: "100%",
    height: "100%",
    minHeight: 0,
  },
  "& .dashboard-counter-icon": {
    backgroundColor: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .dashboard-main-panels .medicationList": {
    flex: "0 0 auto",
    paddingLeft: 0,
    whiteSpace: "nowrap",
  },
  " .care::before": {
    content: '""',
    position: "absolute",
    left: "0",
    top: "0",
    width: "100%",
    height: "97%",
    background:
      "linear-gradient(to right, rgb(235 234 234 / 90%), rgba(255, 255, 255, 0))",
    backdropFilter: "blur(2px)",
    borderRadius: "10px",
    textAlign: "center",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },

  ".JobCardLayout::after": {
    content: '""' /* Empty content as images in content don't allow styling */,
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "20px",
    height: "20px",
    background: `url(${IMAGES.Lock.src})`,
    backgroundSize: "contain",
    zIndex: "9",
  },
  ".blurBox::after": {
    background: `url(${IMAGES.Lock.src})  no-repeat center center`,

    /* Ensures it's above the blurred background */
  },
  " .JobCardLayout::before": {
    content: '""',
    zIndex: "9",
    position: "absolute",
    left: "0",
    width: "98%",
    height: "389px",
    background:
      "linear-gradient(to right, rgb(235 234 234 / 90%), rgba(255, 255, 255, 0))",
    backdropFilter: "blur(2px)",
    borderRadius: "10px",
    textAlign: "center",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  ".care::after": {
    content: '""' /* Empty content as images in content don't allow styling */,
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "20px",
    height: "20px",
    background: `url(${IMAGES.Lock.src})`,
    backgroundSize: "contain",
  },
  [theme.breakpoints.between("md", "lg")]: {
    "& .JobCard": {
      paddingTop: "0",
      width: "100% !important",
      boxSizing: "border-box",
    },
    "& .LastWeekData": {
      padding: "12px",
      width: "100% !important",
      boxSizing: "border-box",
    },
    // " .addMember ": {
    //   top: "288px",
    //   width: "217px !important",
    //   fontSize: "14px !important",
    // },
    "p.content": {
      width: "197px !important",
      whiteSpace: "nowrap",
    },
  },
  [theme.breakpoints.down("sm")]: {
    "& .dashboard-main-panels > .MuiGrid-root": {
      height: "560px",
      minHeight: "560px",
    },
    "& .dashboardchart": {
      height: "220px",
      minHeight: "220px",
      overflow: "hidden",
    },
  },
}));
export default DashboardStyled;
